import { SimpleOption } from '../../../../../components/Option'
import { controlList } from '../../../storage'
import writeXlsxFile from 'write-excel-file'
import { get } from '../../../../../utilities/http'
import { buildPath } from '../../../../../sections/ModalPrint/utils'
import { InventoryBookExcel } from '../../../types'
import Notify from '../../../../../utilities/Notify'
import moment from 'moment'

export default function OptionExcel() {
    async function download() {
        try {
            const companyId = controlList.filter.getParam('company_id')
            const startDate = moment(
                controlList.filter.getParam('start_date')
            ).format('YYYY-MM-DD')
            const endDate = moment(
                controlList.filter.getParam('end_date')
            ).format('YYYY-MM-DD')

            const response = await get<InventoryBookExcel[]>(
                buildPath('/v5.6/apis/inventory_book/excel', [
                    ['company_id', companyId],
                    ['start_date', startDate],
                    ['end_date', endDate]
                ])
            )

            const data = response.data?.result || []
            const totals = (response.data as any)?.totals || {
                initial_inventory_balance: 0,
                final_inventory_balance: 0
            }

            const dateRow1 = [
                { value: '' },
                { value: '' },
                {
                    value: 'Fecha Inicial:',
                    fontWeight: 'bold' as const,
                    backgroundColor: '#e7e6e6'
                },
                {
                    value: startDate,
                    backgroundColor: '#f2f2f2'
                },
                {
                    value: 'Fecha Final:',
                    fontWeight: 'bold' as const,
                    backgroundColor: '#e7e6e6'
                },
                {
                    value: endDate,
                    backgroundColor: '#f2f2f2'
                },
                { value: '' },
                { value: '' }
            ]

            const emptyRow = [
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' },
                { value: '' }
            ]

            const headerRow1 = [
                {
                    value: '',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#f0f0f0'
                },
                {
                    value: '',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#f0f0f0'
                },
                {
                    value: 'Saldo Inicial',
                    span: 2,
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#d9d9d9'
                },
                {
                    value: '',
                    fontWeight: 'bold' as const,
                    backgroundColor: '#d9d9d9'
                },
                {
                    value: '',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#f0f0f0'
                },
                {
                    value: '',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#f0f0f0'
                },
                {
                    value: 'Saldo Final',
                    span: 2,
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#d9d9d9'
                },
                {
                    value: '',
                    fontWeight: 'bold' as const,
                    backgroundColor: '#d9d9d9'
                }
            ]

            const headerRow2 = [
                {
                    value: 'Código Artículo',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#f0f0f0'
                },
                {
                    value: 'Descripción',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#f0f0f0'
                },
                {
                    value: 'Cantidad',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#e8e8e8'
                },
                {
                    value: 'Costo',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#e8e8e8'
                },
                {
                    value: 'Entradas',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#f0f0f0'
                },
                {
                    value: 'Salidas',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#f0f0f0'
                },
                {
                    value: 'Cantidad',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#e8e8e8'
                },
                {
                    value: 'Costo',
                    fontWeight: 'bold' as const,
                    align: 'center' as const,
                    backgroundColor: '#e8e8e8'
                }
            ]

            const dataRows = data.map((row: InventoryBookExcel) => [
                { value: row.product_code, type: String },
                { value: row.product_description, type: String },
                {
                    value: row.initial_inventory_quantity,
                    type: Number,
                    format: '0',
                    align: 'center' as const
                },
                {
                    value: row.initial_inventory_balance,
                    type: Number,
                    format: '0.00',
                    align: 'center' as const
                },
                {
                    value: row.inputs,
                    type: Number,
                    format: '0',
                    align: 'center' as const
                },
                {
                    value: row.outputs,
                    type: Number,
                    format: '0',
                    align: 'center' as const
                },
                {
                    value: row.final_inventory_quantity,
                    type: Number,
                    format: '0',
                    align: 'center' as const
                },
                {
                    value: row.final_inventory_balance,
                    type: Number,
                    format: '0.00',
                    align: 'center' as const
                }
            ])

            // Fila de totales
            const totalsRow = [
                {
                    value: 'TOTALES',
                    fontWeight: 'bold' as const,
                    backgroundColor: '#ffeb9c'
                },
                {
                    value: '',
                    backgroundColor: '#ffeb9c'
                },
                {
                    value: '',
                    backgroundColor: '#ffeb9c'
                },
                {
                    value: totals.initial_inventory_balance,
                    type: Number,
                    format: '0.00',
                    align: 'center' as const,
                    fontWeight: 'bold' as const,
                    backgroundColor: '#ffeb9c'
                },
                {
                    value: '',
                    backgroundColor: '#ffeb9c'
                },
                {
                    value: '',
                    backgroundColor: '#ffeb9c'
                },
                {
                    value: '',
                    backgroundColor: '#ffeb9c'
                },
                {
                    value: totals.final_inventory_balance,
                    type: Number,
                    format: '0.00',
                    align: 'center' as const,
                    fontWeight: 'bold' as const,
                    backgroundColor: '#ffeb9c'
                }
            ]

            const excelData = [
                dateRow1,
                emptyRow,
                emptyRow,
                headerRow1,
                headerRow2,
                ...dataRows,
                totalsRow
            ]

            // Configurar anchos de columnas
            const columns = [
                { width: 20 },
                { width: 70 },
                { width: 18 },
                { width: 18 },
                { width: 15 },
                { width: 15 },
                { width: 18 },
                { width: 18 }
            ]

            const fileName = `libro_inventario_${startDate}_${endDate}.xlsx`

            await writeXlsxFile(excelData, {
                fileName,
                columns
            })

            Notify.success('El archivo Excel se ha descargado correctamente')
        } catch (error) {
            Notify.error(
                'No se pudo descargar el reporte. Por favor, intenta nuevamente.'
            )
        }
    }

    return <SimpleOption onClick={download}>Exportar en Excel</SimpleOption>
}
